
import React from "react";
import "./AirbnbCleaningService.css";

const AirbnbCleaningService = () => {
  return (
    <div className="airbnb-cleaning-container">
      <h1>5 Star Clean for Every Guest</h1>
      <p>
        We help Airbnb hosts maintain impeccable standards with reliable and detailed cleaning
        services between stays. Our Airbnb Cleaning ensures your rental is spotless, sanitized,
        and guest-ready every time.
      </p>

      <h2>What’s Included:</h2>
      <ul>
        <li>Change of linens and bed making</li>
        <li>Bathroom sanitation and restocking supplies</li>
        <li>Kitchen surface cleaning and appliance wipe-downs</li>
        <li>Trash removal and odor control</li>
        <li>Floor vacuuming and mopping</li>
        <li>Reporting damages or guest issues (optional)</li>
      </ul>

      <h2>Why Choose Us for Airbnb Cleaning?</h2>
      <ul>
        <li>🏨 <strong>Consistent Quality</strong> – Impress every guest, every time.</li>
        <li>🕐 <strong>Fast Turnaround</strong> – We adapt to your booking schedule.</li>
        <li>💡 <strong>Attention to Hosting Details</strong> – From folded towels to stocked supplies.</li>
        <li>📲 <strong>Easy Communication</strong> – Get updates, photos, and alerts when needed.</li>
        <li>⭐ <strong>Help Boost Your Ratings</strong> – A cleaner space means happier reviews.</li>
      </ul>
    </div>
  );
};

export default AirbnbCleaningService;
